import { BasicSelect, MultiSelect } from 'vue-search-select'
import CryptoJS from 'crypto-js'
import Pagination from './../../../shared/components/pagination'
import CustomExpandableTable from '../../../shared/components/customExpandableTable'
import Loader from '../../../shared/components/loader'
import CONSTANT from './../../../shared/constants/constant'
import Util from './../../../shared/util/util'
import Treeselect from '@riophae/vue-treeselect'
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'
import BulkReviewFtcDeposit from '../bulkreviewftcdeposit'
const moment = require('moment')

export default {
  name: 'FTCCashDepositList',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    Multiselect,
    BulkReviewFtcDeposit
  },
  data: function () {
    return {
      createFTCCashDeposit: false,
      showRejectHubDeposit: false,
      viewDepositSlip: false,
      isLoading: false,
      isDepositSlipLoading: false,
      companyNamelist: [],
      innerTableColumn: ["Assigned Territory"],
      tableColumn: [
        "WayBill No",
        "Cash Deposit ID",
        "Hub Name",
        "Amount deposited(INR)",
        "Deposit Slip Number",
        "Deposit Date",
        "Created Date",
        "Deposit by",
        "Deposit Status",
        "Action",
      ],
      tableItems: [],
      depositStatuslist: [
        { id: 0, label: "To be verified" },
        { id: 1, label: "Accepted" },
        { id: 2, label: "Rejected" },
      ],
      depositStatus: null,
      selectedHub:null,
      selectedhub: null,
      hublist: [],
      branchlist: [],
      Accountlist:[],
      rejectionReasonlist: [
        { id: "Complete image of slip not uploaded", label: "Complete image of slip not uploaded" },
        { id: "Damaged Deposit Slip", label: "Damaged Deposit Slip" },
        { id: "Incompletely Filled Deposit Slip", label: "Incompletely Filled Deposit Slip"},
        { id: "Bank Stamp Missing", label: "Bank Stamp Missing" },
        { id: "FTC Amount not matching", label: "FTC Amount not matching" },
        { id: "Incorrect Details on Deposit Slip", label: "Incorrect Details on Deposit Slip" },
      ],
      banklist: [],
      branchName: null,
      accountNumber: null,
      rejectionReason: null,
      bankName: null,
      depositSlipNumber: '',
      cashDepositID: '',
      totalPage: 0,
      currentPage: 1,
      total: 0,
      totalCount: 0,
      perPage: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      offset: 0,
      radToDate: "",
      radFromDate: "",
      companyName: "",
      AWB: "",
      Action: "",
      ID: "",
      selectedBankName:"",
      DepositID: "",
      DepositedAmt: "",
      bankmasterlist:'',
      HubName: "",
      depositFromDate: null,
      depositToDate: null,
      Reason : "",
      Bankname : "",
      Branchname:'',
      depositSlipImageDownload:'',
      imageLoader:false,
      showImgDownloadBtn:false,
      imageLoader:false,
      toBeVerified:'',
      approved:'',
      rejected: '',
      uploadReviewedcsv: false,
      ftcapprovalLapsedTime: false,
      selectedFilterItem: null,
      userName: '',
      showDepositWaybill: false,
      depositDetailsArray: [],    
      selectedDtpFromDate: null,
      dtpFromDate: null,
      dtpToDate: null,
      todaysDate: '',
      validDateRange: '',
      validDateRangeFrom: '',
      todaysDate1: '',
      validDateRangeFrom1: '',

      deliveryStartDate : null,
      deliveryEndDate : null,
      validDateRange1: null,
      deliveryStartDateError : '',
      deliveryEndDateError: '',
      selectedDeliveryStartDate: null,
      depositSlipToDisplay:''
    };
  },
  computed: {},
  async mounted() {    
    var userdetailEncrypt = window.localStorage.getItem(
      'cargoAutoaccessuserdata'
    )
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
    var plaintext = bytes.toString(CryptoJS.enc.Utf8)
    var userdetail = JSON.parse(plaintext)
    this.hubid = userdetail.hubID[0];
    this.userName = userdetail.email;
    this.localuserid = userdetail.userid;
    this.isLoading = true;
    await Promise.all([
      this.GetDepositListing(),
      this.gethubcashfinance(),
      this.getHubAccessList(),
      this.getbanklisitng()
    ])
    this.isLoading = false;
  },
  methods: {
  checkStartDate() {
      // this.selectedDeliveryDate = moment().subtract(4, 'days').format('YYYY-MM-DD').valueOf();
      this.selectedDeliveryDate = moment(this.selectedDeliveryStartDate).add(14, 'days').format('YYYY-MM-DD').valueOf();
      this.validDateRangeFrom1 = moment.utc(this.depositToDate).format("YYYY-MM-DD").valueOf();

      if (this.depositToDate > this.selectedDeliveryDate) {
          this.$alertify.error("Please select date range should be less than or equal to 15 Days")
          this.depositToDate = null;
      }
      if (this.depositToDate != null) { this.deliveryEndDateError = false }
      if (this.depositToDate > this.todaysDate1) {
          this.$alertify.error("Please select today's date")
          this.depositToDate = null;
      }
  },
  checkEndDate() {
    this.depositToDate = null;
    this.todaysDate1 = moment().format('YYYY-MM-DD');
    this.selectedDeliveryStartDate = moment.utc(this.depositFromDate).format("YYYY-MM-DD").valueOf();
    this.selectedDeliveryDate = moment(this.selectedDeliveryStartDate).add(14, 'days').format('YYYY-MM-DD').valueOf();

    if (this.selectedDeliveryStartDate <= this.todaysDate1 && this.selectedDeliveryStartDate <= this.selectedDeliveryDate) {
        this.validDateRange1 = this.selectedDeliveryDate
        this.deliveryStartDateError = false
    } else {
        this.validDateRange1 = this.todaysDate1
        this.deliveryStartDateError = false
    }
    if (this.depositFromDate != null) { this.deliveryStartDateError = false }
},
    checkToDate() {
      this.dtpToDate = null;
      this.todaysDate = moment().format('YYYY-MM-DD');
      this.selectedDtpFromDate = moment.utc(this.dtpFromDate).format("YYYY-MM-DD").valueOf();
      if (this.selectedDtpFromDate >= this.todaysDate) {
          this.validDateRange = this.todaysDate
      } else {
          this.validDateRange = this.selectedDtpFromDate
      }
  },
  checkFromDate() {
      this.validDateRangeFrom = moment.utc(this.dtpToDate).format("YYYY-MM-DD").valueOf();
      if (this.dtpToDate > this.todaysDate) {
          this.$alertify.error("Please select less than todays date")
          this.dtpToDate = null;
      }
  },
    async gethubcashfinance(){
      try {
        this.isLoading = true;
        let data = await TripServices.getFinanceCashDepositDetails({hubid:this.hubid});
        if(data.data.code == 200 ){
          this.toBeVerified = data.data.data.tobeverifed;
          this.approved = data.data.data.approved
          this.rejected = data.data.data.rejected;
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    async prepareInputPayload(flag) {
      let input = {
        "offset": this.offset,
        "limit": this.pageLimit
      }
      if (this.cashDepositID) {
        input.cashdepositid = this.cashDepositID
      }
      if (this.depositSlipNumber) {
        input.depositslipno = this.depositSlipNumber
      }
      if (this.depositStatus != null) {
        input.depositstatus = this.depositStatus
      }
      if (this.selectedHub) {
        input.hubid = this.selectedHub.value
      }
      if (this.depositFromDate) {
        if (this.depositFromDate > this.depositToDate) {
          this.isLoading = false
          this.$alert("From-Date Must be Less Than To-Date","FTC Finance Cash Deposit","error");
          return true;
        }
      }  
      if (this.depositToDate) {
        if (this.depositFromDate > this.depositToDate) {
          this.isLoading = false
          this.$alert("From Date Must be Less Than To Date","FTC Finance Cash Deposit","error");
          return true;
        }
      }
      if (this.depositFromDate && this.depositToDate) {
        const fromDate = new Date(this.depositFromDate);
        const toDate = new Date(this.depositToDate);
        const differenceInMilliseconds = toDate - fromDate;
        const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
        if (differenceInDays > 15) {
          this.isLoading = false
          this.$alert("Deposit date range should be less than 15 days", "FTC Finance Cash Deposit", "error");
          return true
        } 
      }
      if (this.depositFromDate && !this.depositToDate) {
        this.isLoading = false
        this.$alert("Please select to-date", "FTC Finance Cash Deposit", "error");
          return true
      }
      if (this.depositToDate && !this.depositFromDate) {
        this.isLoading = false
        this.$alert("Please select to-date", "FTC Finance Cash Deposit", "error");
          return true
      }
      if(this.depositFromDate) {
        input.depositdatefrom = this.depositFromDate
      }
      if(this.depositToDate) {
        input.depositedateto = this.depositToDate
      }
      if(this.branchName) {
        input.branch = this.branchName
      }
      if(this.selectedBankName) {
        input.bank = this.selectedBankName
      }
      if(this.accountNumber){
        input.accountno = this.accountNumber
      }
      if(flag){
        input.isexport = 1
      }
      return input;
    },
    async exportSlips(){
      // let tempdata = await this.GetDepositListing(1);
      this.isLoading = true
      let flag = 1
      const input = await this.prepareInputPayload(flag); 
      if (!input) return;
      let result = await TripServices.GetDepositListing(input);
      this.totalCount = result.data.data.count
      let tempData = [];
      let mergeRanges = []; // Array to keep track of merge ranges
      const whiteStyle = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "FFFFFF" }, // White color
        },
      };
      result.data.data.rows.forEach(el => {
        let depositstatus = '';
        if (el.depositsstatus == 0) {
          depositstatus = 'To be verified';
        } else if (el.depositsstatus == 1) {
          depositstatus = 'Accepted';
        } else {
          depositstatus = 'Rejected';
        }
        // Prepare waybills (if available)
        let wayBillNumbers = el.awb ? el.awb.map(val => val.awb) : ['NA'];
        const insertedTimestampFromDB = el.lastmodifieddate;
        const insertedTimestamp = new Date(insertedTimestampFromDB);
        const currentTime = new Date();
        const elapsedMilliseconds = currentTime - insertedTimestamp;
        const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000;
        let ftcamount = el.awb ? el.awb.map(item => parseFloat(item.ftcamount)).reduce((total, amount) => total + amount, 0):0
        this.ftcapprovalLapsedTime = elapsedMilliseconds >= twentyFourHoursInMilliseconds ? false : true;
        const startRowIndex = tempData.length + 1; // Start index for merges
        // Create rows for each waybill
        if(el.awb){
          el.awb.forEach((item, index) => {
            let tdsamount = item.tdsamount ? item.tdsamount : 0
            let responseObj = {
              'id': index === 0 ? el.id : '',
              'Cash Deposit ID': index === 0 ? el.depositid : '',
              'WayBill No': item.awb,
              'Hub Name': el.hubName,
              'FTC Amount (INR)': item.amountwogst ? this.calculatePercent(item.amountwogst,18) : '',
              "TDS Amount (INR)": item.tdsamount ? item.tdsamount : '',
              "TAN Number" : item.tan,
              "Net Collected Amount (INR)": item.ftcamount,
              'Amount deposited(INR)': el.depositamount,
              'Deposit Slip Number': index === 0 ? el.depositslipno : '',
              'Delivery Date and Time':item.deliverydatetime,
              'Deposit Date': index === 0 ? Util.displayDateOnlyFormat(el.depositdate) : '',
              'Deposit by': index === 0 ? el.depositby : '',
              'Deposit Status': index === 0 ? depositstatus :'',
              "Deposit Creation Date": index === 0 ? Util.displayDateOnlyFormat(el.createddate) : '',
              "Finance Verification Date": index === 0 && el.depositsstatus === 1 || el.depositsstatus === 2 ? Util.displayDateOnlyFormat(el.lastmodifieddate) : '',
              "Verified by": index === 0 && el.depositsstatus === 1 || el.depositsstatus === 2 ? el.lastmodifiedby : '',
              "isFTCReject": el.depositsstatus == 1 ? false : el.depositsstatus == 2 ? false : true,
              "isFTCRejectDisabled": el.depositsstatus != 0 ? true : el.depositsstatus == 2 ? false : true,
              "isFTCApprov": el.depositsstatus == 0 ? true : false,
              "isFTCApprovDisabled": el.depositsstatus != 0 ? true : true,
              "isFTCReverse": el.depositsstatus == 1 ? this.ftcapprovalLapsedTime != true ? false : true : false,
              "isFTCReverseDisabled": el.depositsstatus == 1 ? this.ftcapprovalLapsedTime != true ? false : true : false,
            };
            
            if (!flag && index === 0) responseObj['Action'] = 'action'; // Show Action column only on the first row
  
            tempData.push(responseObj);
          });
        }else{
          let responseObj = {
            'id':  el.id ,
            'Cash Deposit ID': el.depositid,
            'WayBill No': 'NA',
            'Hub Name': el.hubName,
            'FTC Amount (INR)': '',
            "TDS Amount (INR)": '',
            "TAN Number" : '',
            "Net Collected Amount (INR)": '',
            'Amount deposited(INR)': el.depositamount,
            'Deposit Slip Number':  el.depositslipno,
            'Delivery Date and Time':'',
            'Deposit Date':  Util.displayDateOnlyFormat(el.depositdate),
            'Deposit by':  el.depositby,
            'Deposit Status':  depositstatus,
            "Deposit Creation Date":  Util.displayDateOnlyFormat(el.createddate),
            "Finance Verification Date":  el.depositsstatus === 1 || el.depositsstatus === 2 ? Util.displayDateOnlyFormat(el.lastmodifieddate) : '',
            "Verified by":  el.depositsstatus === 1 || el.depositsstatus === 2 ? el.lastmodifiedby : '',
            "isFTCReject": el.depositsstatus == 1 ? false : el.depositsstatus == 2 ? false : true,
            "isFTCRejectDisabled": el.depositsstatus != 0 ? true : el.depositsstatus == 2 ? false : true,
            "isFTCApprov": el.depositsstatus == 0 ? true : false,
            "isFTCApprovDisabled": el.depositsstatus != 0 ? true : true,
            "isFTCReverse": el.depositsstatus == 1 ? this.ftcapprovalLapsedTime != true ? false : true : false,
            "isFTCReverseDisabled": el.depositsstatus == 1 ? this.ftcapprovalLapsedTime != true ? false : true : false,
          };
          tempData.push(responseObj);
        }
        if (wayBillNumbers.length > 1) {
          // Merge cells from start to end row
          mergeRanges.push({ s: { r: startRowIndex, c: 0 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 0 } });
          mergeRanges.push({ s: { r: startRowIndex, c: 1 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 1 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 3 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 3 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 8 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 8 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 9 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 9 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 10 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 10 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 11 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 11 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 12 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 12 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 13 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 13 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 14 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 14 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 15 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 15 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 16 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 16 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 17 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 17 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 18 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 18 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 19 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 19 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 20 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 20 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 21 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 21 } }); 
          mergeRanges.push({ s: { r: startRowIndex, c: 22 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 22 } }); 
        }
      });

      let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
      const data = XLSX.utils.json_to_sheet(tempData);
      const wb = XLSX.utils.book_new();
      data['!merges'] = mergeRanges;
      XLSX.utils.book_append_sheet(wb, data, 'data')
      XLSX.writeFile(wb,dt+'depositslips.xlsx');
      this.isLoading=false
    },
    search(){
      this.currentPage = 1;
      this.offset = 0;
      this.GetDepositListing();
    },
    calculatePercent(value,percent){
      let gst =  Number(Number((value/100)*percent).toFixed(2)) ;
      return Math.round(Number(Number(value) + Number(gst)))
    },
    selectBank(el){
      let bankRecord = this.bankmasterlist.find(item=>item.BankMasterId == el.id);
      this.selectedBankName = bankRecord.BankName;
      // this.accountNumber = bankRecord.AccountNo?bankRecord.AccountNo:'';
      // this.branchName = bankRecord.BranchName?bankRecord.BranchName:'';
    },
    async getbanklisitng(){
      try {
        // this.isLoading = true;
        let result = await TripServices.getBankListing({});
        if(result.data.code == 200){
          this.bankmasterlist = result.data.data
          this.banklist = [];
          this.bankmasterlist.forEach(el=>{
            this.banklist.push({
              id : el.BankMasterId,
              label : el.BankName
            })
          })
        }
        // this.isLoading = false;
      } catch (err) {
        console.log(err)
        // this.isLoading = false;
      }
    },
    async GetDepositListing (flag,message='') {
      try {
        this.isLoading = true
        const input = await this.prepareInputPayload(flag); 
        if (!input) return;      
        let result = await TripServices.GetDepositListing(input);
        this.totalCount = result.data.data.count
        let tempData = result.data.data.rows.map(el => {
          let depositstatus = ''
          if (el.depositsstatus == 0) {
            depositstatus = 'To be verified'
          } else if (el.depositsstatus == 1) {
            depositstatus = 'Accepted'
          } else {
            depositstatus = 'Rejected'
          }
          let wayBillNumber = el.awb != null ? el.awb.map(val => val.awb) : ['NA']
          const insertedTimestampFromDB = el.lastmodifieddate
          const insertedTimestamp = new Date(insertedTimestampFromDB);
          const currentTime = new Date();
          const elapsedMilliseconds = currentTime - insertedTimestamp;
          const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000;
          if (elapsedMilliseconds >= twentyFourHoursInMilliseconds) {
            this.ftcapprovalLapsedTime = false
          } else {
            this.ftcapprovalLapsedTime = true
          }
          let responseObj = {
            'id': el.id,
            'Cash Deposit ID': el.depositid,
            'WayBill No': wayBillNumber,
            'Hub Name': el.hubName,
            'Amount deposited(INR)': el.depositamount,
            'Deposit Slip Number': el.depositslipno,
            'Deposit Date': el.depositdate,
            'Deposit by': el.depositby,
            'Deposit Status': depositstatus,
            "isFTCReject":el.depositsstatus == 1 ? false : el.depositsstatus == 2 ? false : true,
            "isFTCRejectDisabled":el.depositsstatus != 0 ? true : el.depositsstatus == 2 ? false : true,
            "isFTCApprov":el.depositsstatus == 0 ? true : false,
            "isFTCApprovDisabled": el.depositsstatus != 0 ? true : true,
            "isFTCReverse":el.depositsstatus == 1 ? true : false,
            "isFTCReverse":el.depositsstatus == 1 ? this.ftcapprovalLapsedTime != true ? false : true : false,
            "isFTCReverseDisabled": el.depositsstatus == 1 ? this.ftcapprovalLapsedTime != true ? false : true : false,
            "Created Date":el.createddate ? moment(el.createddate).format("YYYY-MM-DD") : 'NA',
            "awbDetails" : el.awb

          }
          if(!flag) responseObj['Action'] = 'action';
          return responseObj;
        })
        if(flag) {this.isLoading = false;return tempData};
        this.tableItems = tempData;
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
      }
    },

    selectHub(data){
      this.selectedHub = data;
    },
    async getHubAccessList () {
      try {
        let InputPayload = {
          userid: this.localuserid
        }
        this.isLoading = true;
        let response = await TripServices.getHubAccessList(InputPayload)
        let list = response.data.data.hubaccess
        list.forEach(el => {
          this.hublist.push({
            'value': el.HubID,
            'text': el.HubName
          })
        })
      } catch (err) {
        console.log(err)
      }
    },
    async AcceptRejectDeposit (selectedDepositDetails) {
      try {        
        this.isLoading = true;
        let input = {
          id: this.ID,
          action: this.Action,
          hubid: this.hubid,
          awb: selectedDepositDetails['WayBill No'],
          username: this.userName
        }
        if(this.Action == 2){
          input.reason = this.rejectionReason.id
        }
        let response = await TripServices.AcceptRejectDeposit(input)
        if(response.data.code == 200){
          this.ID = '',
          this.Action = '',
          this.rejectionReason = null
          this.showRejectHubDeposit = false
          this.$alertify.success(response.data.message)
          this.GetDepositListing()
        }
        else{
          this.$alertify.error(response.data.message)
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    async rejectDepositSlip() {
      this.AcceptRejectDeposit(this.selectedItem)
    },
    async reverseAcceptedDeposit (selectedDepositDetails) {
      try {        
        this.isLoading = true;
        let input = {
          id: this.ID,
          hubid: this.hubid,
          username:this.localuserid,
          awb:selectedDepositDetails['WayBill No']
        }
        let response = await TripServices.reverseApprovedHubDeposit(input)
        if(response.data.code == 200){
          this.ID = '',
          this.Action = '',
          this.rejectionReason = null
          this.showRejectHubDeposit = false
          this.$alertify.success(response.data.message)
          this.GetDepositListing()
        }
        else{
          this.$alertify.error(response.data.message)
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    async ViewDepositSlip () {
      try {
        // this.isLoading = true
        this.DepositID = '',
        this.DepositedAmt = '',
        this.DepositedAmt = '',
        this.HubName = '',
        this.Reason = '',
        this.Bankname = '',
        this.Branchname = ''
        let input = {
          id: this.ID,
        }
        let response = await TripServices.ViewHubCashDepositSlip(input);
        if(response.code = 200){
          this.DepositID = response.data.data.depositid
          this.DepositedAmt = response.data.data.depositamount
          this.HubName = response.data.data.hubname
          this.Reason = response.data.data.rejectreason;
          this.Bankname = response.data.data.bankname
          this.Branchname = response.data.data.branchname
          // this.isLoading = false
          if(response.data.data.depositslipimage){
            document.getElementById("image").src = response.data.data.depositslipimage; 
          }
        }
        else{
          alert(response.message)
        }
      } catch (error) {
        console.log(error);  
      }
    },
    imgPlaceholder(e){
      this.showImgDownloadBtn=true;
    },
    async DownloadDepositSlip () {
      try {
        let input = {
          id: this.ID,
        }
        let response = await TripServices.ViewHubCashDepositSlip(input);
        this.depositSlipImageDownload=response.data.data.depositslipimage;  
        if(response.status = 200){ 
          if (this.depositSlipImageDownload != null && !this.showImgDownloadBtn) {
          var link = document.createElement('a');
          link.setAttribute('href', this.depositSlipImageDownload);
          var fileName = this.depositSlipImageDownload.split('/').pop();
          link.setAttribute('download', fileName);
          link.click();
          // document.body.removeChild(link);
          } else{  
          this.$alert("image not present");
          }
        }else{
          this.$alert("image not present");
          }
      }catch(err) {
        console.log(err.message);
      }
    },
    async resetFilter () {
      try {
        this.cashDepositID = null
        this.depositSlipNumber = null
        this.depositStatus = null
        this.selectedHub =null
        this.depositFromDate = null
        this.depositToDate = null
        this.branchName = null
        this.bankName = null
        this.accountNumber = null
        this.selectedBankName = null
        this.onPageChange(1)
        this.GetDepositListing()
      }catch(err) {
        console.log(err)
      }
    },
  
    callParent () {
      this.createFTCCashDeposit = false
      this.gethubcashfinance()
    },
    showFTCCashDeposit () {
      this.createFTCCashDeposit = true
    },
    onPageChange(page){
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.GetDepositListing();
    },
    showDepositSlip () {
      this.viewDepositSlip = true;
      let image = document.getElementById('image');
      this.imageLoader = true;
      if(image.complete){
        this.imageLoader = false;
      }else{
        image.onload = () => {
          this.imageLoader = false;
        };
        image.onerror = () => {
          this.imageLoader = false;
        }
      }
    },
    filterClick() {      
      this.uploadReviewedcsv = false
    },
    getCustomTableEvent(event) {
      var item = this.tableItems.find(item => item.id === event.id);
      this.depositSlipToDisplay = item['Cash Deposit ID']
      this.selectedFilterItem = item
      this.selectedItem = item
      if (event.actionType == 'approve') {
        this.ID = event.id
        this.Action = 1
        let messageString = `
      <i class="fa fa-question-circle fa-4x" aria-hidden="true" style="color: #569e56;"></i><br><br>
      <p>Thank you for reviewing the deposit details. Please confirm the following information</p> 
      <table class="table table-bordered" id="details" style="width:100%">
      <tr><th class="text-center">Deposit Id</th><th class="text-center">Settlement Amount</th></tr>
      <tr><th class="text-center">${ item['Cash Deposit ID'] }</th><th class="text-center">${item['Amount deposited(INR)']}</th><tr>
      </table>
      <p><strong>Do you wish to approve this deposit?</strong></p>
      `
        this.$fire({
          icon: "success",
           html: messageString,
           width: 500,
           textalign: 'center',          
           reverseButtons: true,
           showCancelButton: true,
           cancelButtonColor: '#20a8d8',
           confirmButtonColor: '#009C41',
           confirmButtonText: '<i class="fa fa-thumbs-up"></i> Yes, Approved',
           cancelButtonText: '<i class="fa fa-times-circle-o"></i> Cancle',         
           }).then((result) => {
             if(result.value == true) {
              this.AcceptRejectDeposit(item)
              }
           }).catch((err)=>{
            console.log(err)
          });        
      }
      if (event.actionType == 'reject' || event.actionType == 'view') {
        if(event.actionType == 'reject') {
          this.showRejectHubDeposit = true
        }
        this.ID = event.id
        this.showImgDownloadBtn=false
        this.Action = 2
        this.ViewDepositSlip()
      }
      if (event.actionType == 'reverse') {
        let messageString = `
        <i class="fa fa-exclamation-circle fa-4x" aria-hidden="true" style="color: #569e56;"></i><br><br>
        <p>You are about to reverse a previously approved deposit.Please double-check the details before proceeding</p> 
        
        <p><strong>Do you wish to proceed with the reversal?</strong></p>
        `
          this.$fire({
             html: messageString,
             width: 500,
             textalign: 'center',          
             reverseButtons: true,
             showCancelButton: true,
             cancelButtonColor: '#20a8d8',
             confirmButtonColor: '#009C41',
             confirmButtonText: '<i class="fa fa-thumbs-up"></i> Yes',
             cancelButtonText: '<i class="fa fa-times-circle-o"></i> Cancle',         
             }).then((result) => {
               if(result.value == true) {
                this.ID = event.id
                this.action = 3
                this.reverseAcceptedDeposit(item)
                }
             }).catch((err)=>{
              console.log(err)
            });        
      }
      if (event.actionType == "viewWaybill") {
        this.depositDetailsArray = item.awbDetails;
        this.showDepositWaybill = true;
    }
    },
    onClickBulkReview() {
      let input = {
        "offset": this.offset,
        "limit": this.pageLimit
      }
      input.depositstatus = 0 // it should be zero only becausewe are fetching only pending data
      if (this.cashDepositID) {
        input.cashdepositid = this.cashDepositID
      }
      if (this.depositSlipNumber) {
        input.depositslipno = this.depositSlipNumber
      }    
       
      if (this.selectedHub) {
        input.hubid = this.selectedHub.value
      }
      if(this.depositFromDate) {
        input.depositdatefrom = moment(this.depositFromDate).format('YYYY-MM-DD');
      }
      if(this.depositToDate) {
        input.depositedateto = moment(this.depositToDate).format('YYYY-MM-DD');
      }
      if(this.branchName) {
        input.branch = this.branchName
      }
      if(this.selectedBankName) {
        input.bank = this.selectedBankName
      }
      if(this.accountNumber){
        input.accountno = this.accountNumber
      }
        input.isexport = 1
      this.selectedFilterItem = {input}
      this.uploadReviewedcsv = true;
    },
    showFtcCashDesposit() {
			this.uploadReviewedcsv = false
    },
    handleFile(file) {
      // Handle the file upload, e.g., send it to the server, save in the database, etc.
      const formData = new FormData();
      formData.append('file', file);
      // Example: You might use Axios or another method to send the file to the server
      // axios.post('/upload', formData).then(response => {
      //   console.log(response.data);
      //   // Handle the server response, such as saving the file details in the database
      // });
      // For simplicity, this example just logs the file details
    }

  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FTCFinanceCashDeposit/FTCFinanceCashDeposit.component.js